module.exports = __webpack_public_path__ + "img/new4.9b3915a9.png";